import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Delete vehicles
 *
 * @private
 */
export const deleteVehicles = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/vehicle/delete', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/vehicle/delete', {
      category: 'rpc',
      type: 'rpc/vehicle/delete',
      vehicleIds: payload,
    })
    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {deleteVehicles}`,
      { tags: ['rpc', 'vehicles'], info: payload },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Delete vehicles failed`,
      error,
    })
  }
})
